import { Event } from "../../events/Event";
import { SkinnedMeshRenderer } from "./SkinnedMeshRenderer";
import { SubMeshRenderElement } from "./render/SubMeshRenderElement";
import { SkinnedMeshSprite3DShaderDeclaration } from "./SkinnedMeshSprite3DShaderDeclaration";
import { Vector2 } from "../../maths/Vector2";
import { Vector4 } from "../../maths/Vector4";
import { BaseRenderType } from "../../RenderDriver/RenderModuleData/Design/3D/I3DRenderModuleData";
import { Laya3DRender } from "../RenderObjs/Laya3DRender";
import { SimpleSkinnedMeshSprite3D } from "./SimpleSkinnedMeshSprite3D";
import { LayaGL } from "../../layagl/LayaGL";
import { StatElement } from "../../layagl/StatisticsContext";
import { Browser } from "../../utils/Browser";
export class SimpleSkinnedMeshRenderer extends SkinnedMeshRenderer {
    get simpleAnimatorTexture() {
        return this._simpleAnimatorTexture;
    }
    set simpleAnimatorTexture(value) {
        this._simpleAnimatorTexture = value;
        this._simpleAnimatorTextureSize = value.width;
        this._baseRenderNode.shaderData.setTexture(SimpleSkinnedMeshSprite3D.SIMPLE_SIMPLEANIMATORTEXTURE, value);
        this._baseRenderNode.shaderData.setNumber(SimpleSkinnedMeshSprite3D.SIMPLE_SIMPLEANIMATORTEXTURESIZE, this._simpleAnimatorTextureSize);
    }
    get simpleAnimatorOffset() {
        return this._simpleAnimatorOffset;
    }
    set simpleAnimatorOffset(value) {
        value.cloneTo(this._simpleAnimatorOffset);
    }
    _isISkinRenderNode() {
        return null;
    }
    constructor() {
        super();
        this._simpleAnimatorParams = new Vector4();
        this._simpleAnimatorOffset = new Vector2();
        this._baseRenderNode.shaderData.addDefine(SkinnedMeshSprite3DShaderDeclaration.SHADERDEFINE_SIMPLEBONE);
        this._baseRenderNode.shaderData.addDefine(SkinnedMeshSprite3DShaderDeclaration.SHADERDEFINE_BONE);
        this._baseRenderNode.renderNodeType = BaseRenderType.SimpleSkinRender;
        this._baseRenderNode.shaderData.setVector(SimpleSkinnedMeshSprite3D.SIMPLE_SIMPLEANIMATORPARAMS, new Vector4());
    }
    _createBaseRenderNode() {
        this._ownerSimpleRenderNode = Laya3DRender.Render3DModuleDataFactory.createSimpleSkinRenderNode();
        return this._ownerSimpleRenderNode;
    }
    _getcommonUniformMap() {
        return ["Sprite3D", "SimpleSkinnedMesh"];
    }
    _computeSkinnedData() {
        this._computeAnimatorParamsData();
    }
    renderUpdate(context) {
        let t = Browser.now();
        super.renderUpdate(context);
        this._computeSkinnedData();
        LayaGL.statAgent.recordTimeData(StatElement.T_SkinBoneUpdate, Browser.now() - t);
    }
    _createRenderElement() {
        let renderelement = new SubMeshRenderElement();
        return renderelement;
    }
    _computeAnimatorParamsData() {
        if (this._cacheMesh) {
            this._simpleAnimatorParams.x = this._simpleAnimatorOffset.x;
            this._simpleAnimatorParams.y = Math.round(this._simpleAnimatorOffset.y) * this._bonesNums * 4;
            this._ownerSimpleRenderNode.setSimpleAnimatorParams(this._simpleAnimatorParams);
        }
    }
    setCustomData(value1, value2 = 0) {
        this._simpleAnimatorParams.z = value1;
        this._simpleAnimatorParams.w = value2;
        this._ownerSimpleRenderNode.setSimpleAnimatorParams(this._simpleAnimatorParams);
    }
    _onMeshChange(value) {
        this._onSkinMeshChange(value);
        if (!value)
            return;
        this._cacheMesh = value;
        this._setRenderElements();
    }
    _cloneTo(dest) {
        dest.simpleAnimatorOffset = this.simpleAnimatorOffset;
        dest.simpleAnimatorTexture = this.simpleAnimatorTexture;
        dest._bonesNums = this._bonesNums;
        super._cloneTo(dest);
    }
    _onDestroy() {
        if (this._cacheRootBone)
            (!this._cacheRootBone._destroyed) && (this._cacheRootBone.transform.off(Event.TRANSFORM_CHANGED, this, this._onWorldMatNeedChange));
        this._simpleAnimatorTexture = null;
        super._onDestroy();
    }
}
